// Pure helpers for the AI models settings section (CONTEXT.md "AI Models").

export const PROVIDERS = [
    { value: 'anthropic', label: 'Anthropic' },
    { value: 'openai', label: 'OpenAI' },
];

const providerLabel = (value) => (PROVIDERS.find(p => p.value === value) || { label: value }).label;

// Enabled models grouped per provider, for the task dropdowns.
export function enabledByProvider(models) {
    return PROVIDERS
        .map(p => ({
            provider: p.value,
            label: p.label,
            models: models.filter(m => m.enabled && m.provider === p.value),
        }))
        .filter(group => group.models.length > 0);
}

// Why an admin might not want this model: not listed any more, or on its
// way out. Empty for a healthy model.
export function modelWarnings(model) {
    const warnings = [];
    if (!model.listed) warnings.push('No longer listed by the provider');
    if (model.shutdown_date) warnings.push(`Provider shuts it down on ${model.shutdown_date}`);
    return warnings;
}

// Catalog rows to show: a search over id and label, disabled rows only on
// request, enabled first, then provider, then label.
export function visibleModels(models, { query = '', showDisabled = false } = {}) {
    const q = query.trim().toLowerCase();
    return models
        .filter(m => showDisabled || m.enabled)
        .filter(m => !q || m.model_id.toLowerCase().includes(q) || m.label.toLowerCase().includes(q))
        .sort((a, b) => (
            Number(b.enabled) - Number(a.enabled)
            || a.provider.localeCompare(b.provider)
            || a.label.localeCompare(b.label)
        ));
}

export function describeRefresh(report) {
    const parts = [
        `${report.added.length} new model${report.added.length === 1 ? '' : 's'} added (disabled)`,
        `${report.unlisted.length} no longer listed`,
    ];
    if (report.skipped.length) {
        parts.push(`skipped ${report.skipped.map(providerLabel).join(', ')} (no API key)`);
    }
    return parts.join(', ') + '.';
}
